import { IsString, Length, Matches } from 'class-validator';

import { passwordRegexp } from '@onArte/shared/regexp';

export class SetPasswordModel {
  @IsString()
  public hash: string;

  @IsString()
  public oldPassword: string;

  @Length(8, 64)
  @Matches(passwordRegexp)
  public newPassword: string;
}
